import { Experiment } from '@eventbrite/consumer-search.discover-utils/types';

export enum OrganizerAutocompleteExperimentValues {
    control = 'control',
    test = 'test',
}

export const OrganizerAutocompleteExperiment: Experiment<
    typeof OrganizerAutocompleteExperimentValues
> = {
    name: 'web_searchbar_autocomplete_organizer_v2',
    paramName: 'variant',
    values: OrganizerAutocompleteExperimentValues,
};
